export { default } from "./Banner-component";
